import moment from 'moment';

import Constants from '@/common/constants';

import { TEapAssignment } from '../types/main';

export const isDeadlineOverdue = (item: TEapAssignment) => {
  if (!item?.deadline) return false;
  if (item.statusId === Constants.eapAssignemntStatusDoneId) return false;

  const deadline = moment(item.deadline).startOf('day');
  const today = moment().startOf('day');

  return deadline.isBefore(today);
};
